<div class="gisApp">
    <section class="singleMap">
        <iframe *ngIf="mapURL" [src]="mapURL" allowfullscreen></iframe>
    </section>
    <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event; showWarning=$event">
    </app-toast>
</div>